import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "justify-content": "space-between",
    "margin": "40px 0",
    "margin-top": "20px"
  }
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_4 = {
  class: "d_bts"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input = _resolveComponent("el-input");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_input = _resolveComponent("vxe-input");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white wrap_box lcpg"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_cache[6] || (_cache[6] = _createElementVNode("label", {
      style: {
        "margin-right": "10px"
      }
    }, "任务名称", -1)), _createVNode(_component_el_select, {
      modelValue: _ctx.data.task_id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.data.task_id = $event),
      placeholder: "请选择",
      clearable: ""
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.taskList, (it, index) => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: index,
          label: it.name,
          value: it.basetask_id
        }, null, 8, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_cache[7] || (_cache[7] = _createElementVNode("label", {
      style: {
        "margin-right": "10px"
      }
    }, "模板名称", -1)), _createVNode(_component_el_input, {
      modelValue: _ctx.data.name,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.data.name = $event),
      placeholder: "请输入模板名称"
    }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      class: "l-button",
      onClick: _cache[2] || (_cache[2] = (...args) => _ctx.search && _ctx.search(...args))
    }, "搜索"), _createElementVNode("div", {
      class: "l-button",
      onClick: _cache[3] || (_cache[3] = (...args) => _ctx.reset && _ctx.reset(...args))
    }, "重置")])]), _createElementVNode("div", {
      class: "l-button",
      style: {
        "margin-bottom": "20px"
      },
      onClick: _cache[4] || (_cache[4] = $event => _ctx.data.reshow = true)
    }, "上传文件 "), _createVNode(_component_vxe_table, {
      id: "ggdytable",
      ref: "getDomN",
      resizable: "",
      "scroll-x": {
        enabled: false
      },
      "row-config": {
        isHover: true
      },
      "scroll-y": {
        enabled: false
      },
      keepSource: "",
      "custom-config": {
        storage: true
      },
      border: "",
      "show-overflow": "",
      data: _ctx.data.mblist,
      "edit-config": {
        trigger: 'click',
        mode: 'cell',
        showStatus: true
      },
      "column-config": {
        resizable: true
      },
      class: "ggdycss",
      "max-height": "500"
    }, {
      default: _withCtx(() => [_createVNode(_component_vxe_column, {
        field: "id",
        title: "模板编号",
        width: "100",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        field: "task_name",
        title: "所属任务",
        width: "252",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        field: "filename",
        title: "文件名称",
        width: "252",
        align: "center"
      }), _createVNode(_component_vxe_column, {
        title: "操作",
        width: "200",
        align: "center"
      }, {
        default: _withCtx(scoped => [_createElementVNode("span", {
          style: {
            "color": "#409eff",
            "cursor": "pointer"
          },
          onClick: $event => _ctx.setIt(scoped.row, scoped.rowIndex, 'xz')
        }, "下载", 8, _hoisted_5), _createElementVNode("span", {
          style: {
            "color": "red",
            "cursor": "pointer",
            "margin-left": "25px"
          },
          onClick: $event => _ctx.setIt(scoped.row, scoped.rowIndex, 'sc')
        }, "删除", 8, _hoisted_6)]),
        _: 1
      }), _createVNode(_component_vxe_column, {
        field: "remark",
        title: "备注",
        "edit-render": {
          autofocus: '.vxe-input--inner'
        },
        align: "left"
      }, {
        edit: _withCtx(scope => [_createVNode(_component_vxe_input, {
          modelValue: scope.row.remark,
          "onUpdate:modelValue": $event => scope.row.remark = $event,
          modelModifiers: {
            trim: true
          },
          maxlenth: "255",
          onBlur: $event => _ctx.remarkblur(scope.row, scope.rowIndex)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_pagination, {
      background: "",
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange,
      "current-page": _ctx.data.page,
      "page-sizes": [50, 100, 150],
      "page-size": _ctx.data.size,
      layout: "total, sizes, prev, pager, next, jumper",
      total: _ctx.data.total
    }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])]), _createVNode(_component_el_dialog, {
      title: "任务选择",
      "model-value": _ctx.data.reshow,
      width: "300px",
      "before-close": _ctx.handleClose,
      center: false
    }, {
      default: _withCtx(() => [_createElementVNode("div", null, [_cache[9] || (_cache[9] = _createElementVNode("label", {
        style: {
          "margin-right": "10px"
        }
      }, "所属任务", -1)), _createVNode(_component_el_select, {
        modelValue: _ctx.data.rwtask_id,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.data.rwtask_id = $event),
        placeholder: "请先选择所属任务"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.taskList, (it, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: it.name,
            value: it.basetask_id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_upload, {
        ref: "uploadRef",
        "file-list": _ctx.data.fileListTableTop,
        class: "upload-demo",
        action: _ctx.data.upLoadUrl,
        style: {
          "display": "flex",
          "flex-direction": "row-reverse"
        },
        "show-file-list": false,
        "on-success": _ctx.uploadAddRow,
        "on-change": _ctx.fileListChange,
        "before-upload": _ctx.beforeAvatarUpload,
        limit: 1,
        "with-credentials": _ctx.data.withcredentials
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          style: {
            "float": "right",
            "margin-top": "20px"
          },
          disable: !_ctx.data.rwtask_id
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("确认上传")])),
          _: 1,
          __: [8]
        }, 8, ["disable"])]),
        _: 1
      }, 8, ["file-list", "action", "on-success", "on-change", "before-upload", "with-credentials"])])]),
      _: 1
    }, 8, ["model-value", "before-close"])]),
    _: 1
  });
}